import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import axiosInstance from "../../utils/axiosInstance";
import { addAppointmentSlots, deleteAppointmentSlot, fetchDoctorProfile } from "../../constants/ApiConstants";
import { Link, useNavigate } from "react-router-dom";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../components/FullPageLoader";
import DoctorDetailHeader from "../../components/DoctorDetailHeader";
import { FaChevronRight, FaX } from "react-icons/fa6";
import { primaryColor } from "../../constants/colors";
import { format4DigitTimeToAmOrPM } from "../../utils/utils";
import MyModal from "../../components/MyModal";
import SecondaryButton from "../../components/SecondaryButton";
import InputField from "../../components/InputField";
import TimeInput from "material-ui-time-picker";
import toast from "react-hot-toast";
export default function DoctorAppointmentSlots() {
  pageTitle("Appointment Slots");

  const initialWeekDays = [
    { dayNumber: 1, dayName: "Monday", slots: [] },
    { dayNumber: 2, dayName: "Tuesday", slots: [] },
    { dayNumber: 3, dayName: "Wednesday", slots: [] },
    { dayNumber: 4, dayName: "Thursday", slots: [] },
    { dayNumber: 5, dayName: "Friday", slots: [] },
    { dayNumber: 6, dayName: "Saturday", slots: [] },
    { dayNumber: 7, dayName: "Sunday", slots: [] },
  ];
  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const [weekDays, setWeekDays] = useState(initialWeekDays);
  const [doctorDetail, setDoctorDetail] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
        setWeekDays(weekDays.map((it) => ({ ...it, slots: res.data?.data.slots.filter((dt) => dt.weekday == it.dayNumber) })));
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const onAddClick = (weekday) => {
    setModalData({ dayName: weekday.dayName, dayNumber: weekday.dayNumber, time: "", bookingLimit: 1 });
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalData(null);
    setModalOpen(false);
  };

  const onTimeChoose = (t) => {
    setModalData({ ...modalData, time: t });
  };
  function formatTime(time) {
    const hours = time.getHours().toString().padStart(2, "0");
    const minutes = time.getMinutes().toString().padStart(2, "0");
    return `${hours}${minutes}`;
  }

  const handleSubmit = () => {
    if (modalData?.time == "" || modalData?.booking_limit == "") {
      toast.error("Please provide Slot time and Slot Limit");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addAppointmentSlots, {
        doctor_id: doctorId,
        time: formatTime(modalData?.time),
        weekday: modalData?.dayNumber,
        booking_limit: modalData?.bookingLimit,
      })
      .then((res) => {
        setModalData(null);
        setModalOpen(false);
        if (res.data?.status) {
          toast.success("Slot added successfully.");
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err.toString());
        toast.error("Unable to save slot.");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleDeleteSlot = (slotId) => {
    axiosInstance
      .post(deleteAppointmentSlot, {
        doctor_id: doctorId,
        slot_id: slotId,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Slot deleted successfully.");
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err.toString());
        toast.error("Unable to delete slot.");
      })
      .finally(() => {});
  };

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader canBack title="Appointment Slots" />
            <div className="row">
              <div className="col-md-6">
                <div className="py-3 bg-white">
                  <strong className="text-dark fw-medium">Add Appointment slots by week days</strong>
                  <p className="text-grey2 fs-normal">If you have only 2 slots for Monday, then patients can select from those 2 slots for Monday.</p>
                </div>
              </div>
              <div className="col-md-6">
                {weekDays.map((weekday) => (
                  <div key={weekday.dayNumber} className="mb-4 bg-grey2 px-2 py-2">
                    <div className="d-flex justify-content-between align-items center">
                      <strong className="fs-normal fw-medium text-dark">{weekday.dayName}</strong>
                      <button type="button" className="bg-transparent text-primary fw-medium fs-normal" onClick={() => onAddClick(weekday)}>
                        Add
                      </button>
                    </div>
                    {weekday.slots.length > 0 && (
                      <div className="d-flex flex-wrap gap-3 mt-2">
                        {weekday.slots.map((slot) => (
                          <div key={slot.id} className="bg-grey1 px-3 py-1 rounded position-relative">
                            <FaX onClick={() => handleDeleteSlot(slot.id)} className="pointer position-absolute" size={20} style={{ right: -8, top: -8, color: "white", background: "black", padding: 4, borderRadius: 100 }} />
                            <div className="d-flex flex-column">
                              <strong className="text-sprimary fs-normal p-0">{format4DigitTimeToAmOrPM(slot.time)}</strong>
                              <span className="text-grey2 fs-sm">{slot.booking_limit} Slots</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <MyModal isOpen={modalOpen} modalTitle={`Add Slot ( ${modalData?.dayName} )`} onClose={closeModal}>
            <div className="d-flex flex-column gap-2 mt-3 justify-content-center">
              <div className="col-8 mx-auto mb-2 rounded">
                <strong className="text-dark fs-normal fw-normal">Select time</strong>
                <TimeInputWrapper className="bg-grey2 px-3 py-2">
                  <TimeInput mode="12h" onChange={onTimeChoose} />
                </TimeInputWrapper>
              </div>
              <div className="col-8 mx-auto rounded">
                <strong className="text-dark fs-normal fw-normal">Slot limit</strong>
                <InputField value={modalData?.bookingLimit} onChange={(e) => setModalData({ ...modalData, bookingLimit: e.target.value })} />
              </div>
              <SecondaryButton title="Submit" onClick={handleSubmit} loading={submitting} />
            </div>
          </MyModal>
        </Section>
      )}
    </Wrapper>
  );
}
const Wrapper = styled.div``;
const TimeInputWrapper = styled.div`
  .MuiInputBase-input-26::before {
    border-bottom: none !important;
  }
`;
